import React from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../projects/projects.css";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReorderIcon from "@mui/icons-material/Reorder";

export const Fyps = () => {
  const navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
          <Sidebar />
        </Box> */}

        <Box className="col-md-12 col-12">
          <Box className="container">
            <Grid
              container
              className="row"
              sx={{
                gap: "20px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {!currentUser?.isAdmin && (
                <>
                  {currentUser?.userRole == "fypsupervisor" && (
                    <>
                      {" "}
                      <Grid
                        item
                        xs="12"
                        sm="4"
                        className="col-lg-6 container-col col-md-6 col-12 fyp-option-card"
                      >
                        <Link to="/add-new-fyp">
                          <Box className="fyp-option">
                            <AddCircleIcon sx={{ fontSize: "1.5rem" }} />
                            <Typography color="#000">Add New</Typography>
                          </Box>
                        </Link>
                      </Grid>
                      <Grid
                        item
                        xs="12"
                        sm="4"
                        className="col-lg-6 container-col col-md-6 col-12 fyp-option-card"
                      >
                        <Link to="/add-already-created-fyp">
                          <Box className="fyp-option">
                            <CheckCircleIcon />
                            <Typography color="#000">
                              Add Already Created
                            </Typography>
                          </Box>
                        </Link>
                      </Grid>
                    </>
                  )}
                </>
              )}
              {(currentUser?.userRole == "fypsupervisor" ||
                currentUser?.userRole == "student") && (
                <>
                  {" "}
                  <Grid
                    item
                    xs="12"
                    sm="4"
                    className="col-lg-6 container-col col-md-6 col-12 fyp-option-card"
                  >
                    <Link to="/see-already-created-fyp">
                      <Box className="fyp-option">
                        <VisibilityIcon />
                        <Typography color="#000">
                          See Already Created
                        </Typography>
                      </Box>
                    </Link>
                  </Grid>
                  <Grid
                    item
                    xs="12"
                    sm="4"
                    className="col-lg-6 container-col col-md-6 col-12 fyp-option-card"
                  >
                    <Link to="/list-new-fyp-ideas">
                      <Box className="fyp-option">
                        <ReorderIcon />
                        <Typography sx={{ textAlign: "center" }} color="#000">
                          See List of New Projects
                        </Typography>
                      </Box>
                    </Link>
                  </Grid>
                </>
              )}
            </Grid>

            {!currentUser?.isAdmin && (
              <Box className="row mt-4">
                <Typography className="text-center" variant="body2">
                  How to select FYPs in COMSATS?{" "}
                  <a
                    id="click-to-see"
                    href="https://lahore.comsats.edu.pk/cs/fyp/"
                    target="_blank"
                  >
                    Click now to see
                  </a>
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
